module.exports = __webpack_public_path__ + "img/content-img2_1.e71b7686.png";